<template>
  <VMarketpalceVehiclesManagerTable />
</template>
<script>
import VMarketpalceVehiclesManagerTable from '@/components/CarManager/VMarketpalceVehiclesManagerTable.vue'
export default {
  name: 'CarManager',

  components: {
    VMarketpalceVehiclesManagerTable
  }
}
</script>
